<template>
  <ol class="bg-static-info-low rounded-md space-y-16 p-16">
    <li
      v-for="(step, index) in steps"
      :key="step"
      class="flex items-start gap-16"
    >
      <span
        class="bg-static-default-low caption-bold flex size-24 shrink-0 items-center justify-center rounded-full"
      >
        {{ index + 1 }}
      </span>

      <span class="body-2">{{ step }}</span>
    </li>
  </ol>
</template>

<script setup lang="ts">
defineProps<{
  steps: string[]
}>()
</script>
